import React, {useEffect, useState} from 'react';
import Search from "../search/search";
import {Close, CreditIcon, DeleteIcon, EditIcon, KeyIcon} from "../../icons/icons";
import Pagination from "../pagination/pagination";
import DropDown from "../../assets/dropDown/dropDown";
import Sort from "../sort/sort";
import {GetViewType} from "../../utils/view-type";
import Filter from "../filter/filter";
import {useTranslation} from "react-i18next";
import CustomInput from "../UI/customInput/customInput";
import CustomButton from "../UI/customButton/customButton";
import {Delete, Get, Post} from "../../apis/api";
import {toast} from "react-toastify";
import LoadingFix from "../loading-fix/loading-fix";
import DeleteModal from "../deleteModal/deleteModal";
import moment from "moment-jalaali";
import {Separate} from "../../utils/separate";

const UserTable = ({defaultValue , editItem}) => {
  const viewType = GetViewType()
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState( [])
  const [deleteItem, setDeleteItem] = useState( null )
  const [loadingDelete, setLoadingDelete] = useState( false )
  const [idModal, setIdModal] = useState( {} )
  const [perPage, setPerPage] = useState( 10 )
  const [creditModal, setCreditModal] = useState({} )
  const [searchTime, setSearchTime] = useState("")
  const [form, setForm] = useState({})


  useEffect(() => {
    handleList()
  } ,[])



  useEffect(() => {
    setData(defaultValue)
  } ,[defaultValue])


  const handleList = (page , per_page, search="") => {
    setLoading(true)
    Get(`admin/users?page=${page || 1}&per_page=${per_page || 10}&q=${search}` ).then((res) =>{
      setData(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }
  const changePassword = (id) => {
    setLoading(true)
    Post(`admin/users/change-password/${id}` , {...form ,form:"change_password_form"} ).then((res) =>{

      toast.success(res.msg)
    }).finally(() => {
      setLoading(false)
    })
  }
  const handleEdit = (item) => {
    editItem(item)
  }

  const handleDelete = (item) => {
    setDeleteItem(item)
  }

  const changeCredit = (id , method) => {
    setLoading(true)
    Post(`admin/users/change-credit/${id}` , {...form ,form:"change_credit_form" , method:method})
      .then((res) =>{
      setCreditModal({})
      handleList()
      toast.success(res.msg)
    }).catch((error) => {
      toast.error(error.data.message || error.data.msg)

    }).finally(() => {
      setLoading(false)
    })
  }


  const handleCloseDeleteModal = () => {
    setDeleteItem(null)
  }

  const handleDeleteRequest = () => {
    setLoadingDelete(true)
    Delete(`admin/users/destroy/${deleteItem.id}` ).then((res) =>{
      setData(res?.details?.data)
      toast.success(res.msg)
      setDeleteItem(null)
    }).finally(() => {
      setLoadingDelete(false)
    })
  }
  const handleSort = (e) => {
    setData([])
    setTimeout(() => {
      setData(e)
    } ,0)
  }
  const handleForm = ({name, value}) => {
    setForm((prevState) => ({...prevState, [name]: value}))
  }
  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {

      handleList(1 , perPage , e);

    }, 1000)
    setSearchTime(loop)

  }
  return (
    <div className={"my-container"}>
      {
        loading && <LoadingFix/>
      }
      {
        deleteItem && <DeleteModal onClose={handleCloseDeleteModal} onDelete={handleDeleteRequest} loading={loadingDelete}/>
      }
      {
        viewType === "WEB" ?
          <div
            className="relative overflow-x-auto w-full  bg-white rounded-lg  flex flex-col items-center w-full !mt-5 border border-1 border-gray-300 overflow-hidden ">
            <table className="w-full text-sm text-gray-500">
              <thead className="text-xs text-gray-700 uppercase ">
              <tr className={"border-b border-gray-400"}>
                <th scope="col" className="px-6 py-3 text-left w-4 font-normal text-gray-600 text-sm">
                  <div className={"mt-1 text-sm"}>
                    {t("row")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex text-sm"}>
                    <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/>
                    {t("name")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex text-sm"}>
                    <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/>
                    {t("family")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex text-sm"}>
                    <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/>
                    {t("roles")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex text-sm"}>
                    <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/>
                    {t("meli")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex text-sm"}>
                    <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/>
                    {t("phoneNumber")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex text-sm"}>
                    <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/>
                    {t("credit")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left w-[200px] font-normal text-gray-600 text-sm">
                  <Search onChange={handleSearch}/>
                </th>
              </tr>
              </thead>
              <tbody>
              {data?.data?.map((item, index) => (
                <tr key={index} className="bg-white border-b border-gray-400">
                  <td className="px-6 py-4 text-center">
                    <div className={"text-gray-500 text-sm mt-1"}>
                      {index+1}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-start text-primary-400 text-base font-semibold">
                    <div className={"mt-1 text-sm"}>
                      {item.name}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-start text-primary-400 text-base font-semibold">
                    <div className={"mt-1 text-sm"}>
                      {item.last_name}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-start text-primary-400 text-base font-semibold">
                    <div className={"mt-1 text-sm"}>
                      {item.role_key}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-start text-primary-400 text-base font-semibold">
                    <div className={"mt-1 text-sm"}>
                      {item.notional_code}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-start text-primary-400 text-base font-semibold">
                    <div className={"mt-1 text-sm"}>
                      {item.mobile}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-start text-primary-400 text-base font-semibold">
                    <div className={"mt-1 text-sm"}>
                      {Separate(item.credit)}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className={"flex justify-center cursor-pointer"}>
                      <div onClick={() => setIdModal(item)}>
                        <KeyIcon/>
                      </div>
                      <button onClick={()=>handleEdit(item)}>
                        <EditIcon/>
                      </button>
                      <button onClick={() => {
                        setCreditModal(item)
                        setForm(item)
                      }}>
                        <CreditIcon/>
                      </button>
                      {/*<button onClick={()=>handleDelete(item)}>*/}
                      {/*  <DeleteIcon/>*/}
                      {/*</button>*/}
                    </div>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>
          :
          <div className={"grid gap-3 mt-3"}>
            <div className={"bg-white p-3 rounded-lg flex gap-5"}>
              <Filter/>
              <div className={"w-full"}>
                <Search onChange={handleSearch}/>
              </div>
            </div>
            {
              data?.data?.map((item , index) => {
                return (
                  <div className={"flex p-4 rounded-lg bg-white"}>
                    <div className={"flex w-full"}>
                      <div className={"ml-5 min-w-7"}>{index+1}</div>
                      <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                        <div className={"flex w-2/3"}>{item.name + " " + item.last_name}</div>
                        <div className={"flex w-1/3 text-sm text-gray-900 text-center justify-end"}>{item.notional_code}</div>
                        <div className={"flex w-full justify-between"}>
                          <div className={"flex w-1/3 text-sm text-gray-900"}>{item.mobile}</div>
                          <div className={"flex w-1/3 text-sm text-gray-900"}>{Separate(item.credit)}</div>
                          <div className={"flex justify-between cursor-pointer"}>
                            <div onClick={() => setIdModal(item)}>
                              <KeyIcon/>
                            </div>
                            <button onClick={()=>handleEdit(item)}>
                              <EditIcon/>
                            </button>
                            <button onClick={() => {
                              setCreditModal(item)
                              setForm(item)
                            }}>
                              <CreditIcon/>
                            </button>
                            {/*<button onClick={()=>handleDelete(item)}>*/}
                            {/*  <DeleteIcon/>*/}
                            {/*</button>*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
      }
      <div onClick={(e) => e.target === e.currentTarget && setIdModal({}) } className={`${idModal?.name ? "flex" : "hidden"} bg-modal h-full w-full fixed top-0 right-0 z-30  items-center justify-center z-40`}>
        <div className={"bg-white rounded-2xl p-5 w-[350px]"}>
          <div className={"flex items-center mb-8 justify-between"}>
            <span className={'text-primary-400 text-base'}>
              {t("createPassword")}
            </span>
            <span onClick={() => setIdModal({})} className={"cursor-pointer"}>
              <Close color={"#8A9098"}/>
            </span>
          </div>
          <div className={'text-primary-400 text-lg mb-4 text-center font-light'}>
            {t("chooseUser") + " : " + idModal?.name + ' ' + idModal?.last_name}
          </div>
          <div className={' text-lg mb-6 text-center text-sm text-gray-500 font-medium'}>
            {t("createPasswordAlarm")}
          </div>
          <div
            className="relative  bg-white rounded-lg  flex flex-col items-center w-full  overflow-hidden ">
            <div className={"flex flex-col gap-5 w-full"}>
              {/*<span className={"w-full"}>*/}
              {/*   <CustomInput*/}
              {/*     placeHolder={t("userId")}*/}
              {/*     label={t("userId")}*/}
              {/*     name={"userId"}*/}
              {/*   />*/}
              {/*</span>*/}
              <span className={"w-full"}>
                 <CustomInput
                   placeHolder={t("password")}
                   label={t("password")}
                   name={"password"}
                   onchange={(e) => handleForm(e)}
                 />
              </span>
              <div className={"w-full"}>
                <CustomButton onClick={() =>changePassword(idModal?.id)} styles={"text-sm"} title={t("save")}/>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        creditModal?.id &&
        <div onClick={(e) => e.target === e.currentTarget && setCreditModal({}) } className={`${creditModal?.id ? "flex" : "hidden"} bg-modal h-full w-full fixed top-0 right-0 z-30  items-center justify-center z-40`}>
          <div className={"bg-white rounded-2xl p-5 w-[350px]"}>
            <div className={"flex items-center mb-8 justify-between"}>
            <span className={'text-primary-400 text-base'}>
              {t("creditDes")}
            </span>
              <span onClick={() => setCreditModal(false)} className={"cursor-pointer"}>
              <Close color={"#8A9098"}/>
            </span>
            </div>
            <div
              className="relative  bg-white rounded-lg  flex flex-col items-center w-full  overflow-hidden ">
              <div className={"flex flex-col gap-5 w-full"}>
              <span className={"w-full mt-3"}>
                 <CustomInput
                   placeHolder={t("credit")}
                   label={t("credit")}
                   name={"amount"}
                   onchange={(e) => handleForm(e)}
                   separate={true}
                 />
              </span>
                <div className={"flex gap-5 mt-5"}>
                  <div className={"w-full"}>
                    <CustomButton onClick={() =>changeCredit(creditModal?.id , "increase")} styles={"text-sm"} title={t("increase")}/>
                  </div>
                  <div className={"w-full"}>
                    <CustomButton onClick={() =>changeCredit(creditModal?.id , "reduce")} styles={"text-sm bg-transparent !border-red border-2 !text-red"} title={t("decrease")}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div className={'flex flex-col  md:flex-row md:items-center md:justify-between mt-4'}>
        <DropDown onChange={(per_page) => {
          handleList(1, per_page)
          setPerPage(per_page)
        }}/>
        <Pagination itemsPerPage={data?.per_page} total={data?.total} last_page={data?.last_page}  changePage={(page) => handleList(page , perPage)}/>
      </div>
    </div>
  );
};


export default UserTable;

